export default "__VITE_ASSET__DIqwa_wJ__"